import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import ProductCard from './ProductCard';

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  // Inject styles
  useEffect(() => {
    const styleId = 'product-grid-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .product-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
          margin: 0 10px 10px 10px;
        }
        
        @media (max-width: 768px) {
          .product-grid {
            grid-template-columns: 1fr;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('category', 'prints')
        .order('created_at', { ascending: false })
        .range(0, 5);

      if (error) throw error;
      setProducts(data);
    } catch (error) {
      setError(error.message);
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section style={{
        backgroundColor: '#0D0D0D',
        padding: '40px 0',
        textAlign: 'center',
      }}>
        <p style={{ color: '#8A8A8A', fontFamily: "'TASA Orbiter Display', sans-serif" }}>
          Loading products...
        </p>
      </section>
    );
  }

  if (error) {
    return (
      <section style={{
        backgroundColor: '#0D0D0D',
        padding: '40px 0',
        textAlign: 'center',
      }}>
        <p style={{ color: '#E63230', fontFamily: "'TASA Orbiter Display', sans-serif" }}>
          Error loading products: {error}
        </p>
      </section>
    );
  }

  return (
    <section style={{
      backgroundColor: '#0D0D0D',
    }}>
      {/* Product Grid - 3 columns on desktop, 1 on mobile */}
      <div className="product-grid">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

export default ProductGrid;